<template>
    <transition name="fade">
        <div class="dialog" :style="{[direction]: '10%'}">
            {{text}}
            <span :style="{[direction]: '80%'}"></span>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['text', 'left'],
    computed: {
        direction() {
            if (this.left) {
                return 'left';
            }
            return 'right';
        }
    }
};
</script>

<style lang="stylus" scoped>
.dialog
    max-width 5.4rem
    position absolute
    bottom 7rem
    padding .3rem
    font-size .32rem
    line-height .54rem
    color #303030
    border .02rem solid #291f14
    background #fff
    border-radius .2rem
    text-align justify
    span
        content ''
        position absolute
        transform rotate(-45deg)
        bottom -.16rem
        size .3rem
        background #fff
        border-left .02rem solid #291f14
        border-bottom .02rem solid #291f14
</style>
